import { ErrorTracker, AVAILABLE_TRACKERS } from '@hotmart/error-tracker-ui'

import {
  PROJECT_DSN,
  SHOULD_SEND_EVENT_PERCENTAGE
} from './constants'

const environment = process.env.NODE_ENV === 'production' ? 'production' : 'development'

const config = {
  environment,
  dsn: PROJECT_DSN,
  sampleRate: SHOULD_SEND_EVENT_PERCENTAGE
}

export default new (ErrorTracker(AVAILABLE_TRACKERS.SENTRY, config))()
